'use strict';
module.exports = require('../../full/object/iterate-entries');
